import { ID } from "common/entities/IEntity";
import { Entity, Field } from "typegraph";


@Entity({many: "getEnrollments"})
export class Enrollment {

	@Field()
    public id: ID;

	@Field()
	public firstName: string;

	@Field()
	public lastName: string;

	@Field()
	public startedOn: string;

    @Field()
	public dueDate: string;

	@Field()
	public completedOn: string;

	@Field()
	public score: number;

    @Field()
	public maxScore: number;

	@Field()
    public status: string;

}


// WEBPACK FOOTER //
// ./src/panels/testAssignment/entities/Enrollment.ts